import { Box, Grid, IconButton } from '@mui/material';

import { useRef, useLayoutEffect, useState } from 'react';

import { ReactComponent as Close } from 'common/assets/images/drawer-close.svg';

import styles from './SelectableHOC.module.scss';

interface ISelectableHOCProps {
	count: number;
	visible?: boolean;
	children: React.ReactNode;
	element: React.ReactNode;
	handleCancelChange: () => void;
	styleClass?: string;
}

const { cancelIconColor } = styles;
type IAbsoluteBottomHeight = {
	bottom: string;
};
const SelectableHOC = (props: ISelectableHOCProps) => {
	const outDivRef = useRef<any>();
	const [height, setHeight] = useState<IAbsoluteBottomHeight>();

	useLayoutEffect(() => {
		function updateSize() {
			if (outDivRef.current) {
				const containerHeight = outDivRef.current.offsetHeight;
				const windowHeight = window.innerHeight;
				if (
					containerHeight < windowHeight &&
					windowHeight - (containerHeight + outDivRef.current.offsetTop) > 0
				) {
					setHeight({
						bottom: `${
							windowHeight - (containerHeight + outDivRef.current.offsetTop)
						}px`,
					});
				} else {
					setHeight({ bottom: '80px' });
				}
			}
		}
		window.addEventListener('scroll', updateSize);
		updateSize();
		return () => window.removeEventListener('scroll', updateSize);
	}, []);

	const {
		count,
		children,
		element,
		handleCancelChange,
		styleClass,
		visible = count > 1,
	} = props;
	return (
		<Box className={`${styles['selectable-wrapper-parent']}`} ref={outDivRef}>
			{children}
			{visible && (
				<Box className={`${styles['selectable-wrapper-parent-relative']}`}>
					<Grid
						container
						sx={{ width: 'auto', ...height }}
						justifyContent="center"
						padding={1}
						className={`${styleClass} ${styles['selectable-wrapper']}`}
					>
						{visible && (
							<>
								<Grid item className={`${styles['items-selected-grid']}`}>
									{' '}
									{count} Items selected{' '}
								</Grid>
								<Grid item className={styles['cancel-grid']}>
									<IconButton
										size="large"
										onClick={handleCancelChange}
										data-testid="close-button-icon"
										className={styles['close-icon']}
									>
										<Close fill={cancelIconColor} />
									</IconButton>
								</Grid>
								<Grid item className={styles['element-grid']}>
									{element}
								</Grid>
							</>
						)}
					</Grid>
				</Box>
			)}
		</Box>
	);
};
export default SelectableHOC;
